import { AUTH_PREFIX, defaultRequest } from '@/config/api'
import axios from 'axios'

const axiosAuthInstance = axios.create({
    baseURL: AUTH_PREFIX || window.location.origin,
    ...defaultRequest
})

export default axiosAuthInstance
